import { useQuery } from "@tanstack/react-query";
import { Dispatch, useState } from "react";
import { api } from "../api";

export interface IQueryPagination<T = any> {
  paginacao: T[];
  qtd: number;
  qtdpaginas: number;
}

export interface IQueryPaginationResponse<T = any> {
  data: T[],
  refetch: VoidFunction,
  page: number,
  nextPage: VoidFunction,
  lessPage: VoidFunction,
  setPage: Dispatch<number>,
  allPage: number,
  setSize: Dispatch<number>
  isLoading: boolean
}

export const useQueryPagination = <T>(url: string, dependency: any, title?: string, isPost?: boolean): IQueryPaginationResponse<T> => {
  const [page, setPage] = useState(0);

  const [size, setSize] = useState(20);

  const [allPage, setAllPage] = useState(0);

  const nextPage = () => setPage((value) => value++);

  const lessPage = () => setPage((val) => --val);

  const { data = [], refetch, isLoading } = useQuery({
    queryKey: ["query-list-dependence" + title, dependency, page, size],
    queryFn: () =>
      api
      [isPost ? 'post' : 'get']<IQueryPagination>(url, isPost ? { ...dependency, page, size: size } : {
        params: { ...dependency, page, size: size }
      }, isPost ? { params: { ...dependency, page, size: size } } : undefined)
        .then((res) => {
          setAllPage(res?.data?.qtdpaginas);
          return res;
        }),
    select: (data) => {
      return (
        data?.data?.paginacao
      );
    },
  });

  return {
    data,
    refetch,
    page,
    nextPage,
    lessPage,
    setPage,
    allPage,
    setSize,
    isLoading
  };
};
